<div
    class="banner flex items-center gap-3x3 px-4x2 py-3x2 leading-5"
    [ngClass]="{
        'info bg-secondary text-white': infoStyle,
        'traffic-info bg-yellow-alert text-black': trafficInfoStyle,
        'warning bg-danger !text-black': warningStyle,
        '!border-x !border-b !border-solid !border-contrast-yellow !bg-contrast-black !text-contrast-yellow first:!border-t':
            highContrastStyle
    }"
    [attr.aria-label]="bannerAriaLabel"
    (click)="redirectToDetailsPage()"
    (keydown.enter)="redirectToDetailsPage()"
    (keydown.space)="onSpaceKeydown($event)"
    role="button"
    tabindex="0">
    <div class="flex h-8 w-8 items-center justify-center">
        <ion-icon
            class="banner-icon banner-icon--default h-6x2 w-6x2"
            *ngIf="!isHighContrast; else darkIcon"
            src="{{ assetsPath$ | async }}/img/banner/banner-{{ bannerMessage.type.toLowerCase() }}.svg"></ion-icon>
    </div>
    <div class="relative min-w-0 flex-1">
        <p class="line-clamp-2 text-left leading-5" #titleText style="overflow: hidden">
            {{ renderedTitle }}<span *ngIf="isTitleTruncated">...</span> {{ moreWithArrow }}
        </p>
    </div>
</div>

<ng-template #darkIcon>
    <ion-icon
        class="banner-icon banner-icon--dark h-6x2 w-6x2 bg-contrast-black"
        src="{{ assetsPath$ | async }}/img/banner/banner-{{ bannerMessage.type.toLowerCase() }}-dark.svg"></ion-icon>
</ng-template>
